import React, { PropsWithChildren, useEffect, useState } from 'react';
import { FilterPanelContext } from '../../context/FilterPanelContext';
import { useSavedFilters } from '../../hooks/useSavedFilters';
import { FilterPanelProps } from '../../types';

export const FilterPanelProvider: React.FC<
  PropsWithChildren<FilterPanelProps>
> = ({
  children,
  fields,
  values,
  setValues,
  onApply,
  onClear,
  onSearch,
  onBookmark,
  showButtons = true,
  onFilterToggle,
  table_name,
  isInitShow = false,
  isClear = false,
  maxWidth,
}) => {
  const [autocomplete, setAutocomplete] = useState<{ [key: string]: string }>(
    {}
  );
  const [showFilters, setShowFilters] = useState(isInitShow);

  useEffect(() => {
    if (onFilterToggle) {
      onFilterToggle(showFilters);
    }
  }, [showFilters]);

  const {
    presets,
    activePresetId,
    setActivePresetId,
    getSavedFilters,
    onPresetDelete,
    onPresetCreate,
    onPresetChange,
  } = useSavedFilters({
    table_name,
  });

  return (
    <FilterPanelContext.Provider
      value={{
        fields,
        values,
        setValues,
        onApply,
        onClear,
        onSearch,
        onBookmark,
        showButtons,
        table_name,
        onFilterToggle,
        autocomplete,
        setAutocomplete,
        showFilters,
        setShowFilters,
        activePresetId,
        setActivePresetId,
        presets,
        getSavedFilters,
        handleDeleteFilter: onPresetDelete,
        onPresetCreate,
        onPresetChange,
        isClear,
        maxWidth,
      }}
    >
      {children}
    </FilterPanelContext.Provider>
  );
};
